export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
}

export const categories: ComicCategory[] = [
  { slug: "rexue", name: "热血", icon: "ri-fire-line" },
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line" },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "maoxian", name: "冒险", icon: "ri-compass-line" },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line" },
  { slug: "kehuan", name: "科幻", icon: "ri-rocket-line" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line" },
  { slug: "dongzuo", name: "动作", icon: "ri-run-line" },
  { slug: "xiaoyuan", name: "校园", icon: "ri-book-open-line" },
  { slug: "danmei", name: "耽美", icon: "ri-star-line" },
  { slug: "baihe", name: "百合", icon: "ri-flower-line" },
];